import React from "react";


export function FolderTree({ folders, currentFolder, onFolderClick, level = 0 }) {
  if (!folders || folders.length === 0) return null;

  return (
    <div>
      {folders.map((folder) => (
        <div key={folder.id} style={{ marginLeft: `${level * 15}px`, marginTop: "4px" }}>
          <button
            className={`tab-button ${folder.caption === currentFolder ? "active" : ""}`}
            onClick={() => onFolderClick(folder.caption)} // ✅ use prop
            style={{ textAlign: "left", width: "100%" }}
          >
            {folder.caption}
          </button>

          {folder.children && folder.children.length > 0 && (
            <FolderTree
              folders={folder.children}
              currentFolder={currentFolder}
              onFolderClick={onFolderClick} // ✅ pass prop down recursively
              level={level + 1}
            />
          )}
        </div>
      ))}
    </div>
  );
}
